module.exports = __webpack_public_path__ + "img/llorens.3aa66af1.jpg";